/** Convite de instalação do PWA. Botão no Android/desktop, dica no iOS. Onda 19. */
import { useEffect, useState } from "react";
import { Button } from "./Button";

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
}

export function InstallPrompt() {
  const [deferred, setDeferred] = useState<BeforeInstallPromptEvent | null>(null);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    const onPrompt = (e: Event) => {
      e.preventDefault();
      setDeferred(e as BeforeInstallPromptEvent);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);

    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (navigator as unknown as { standalone?: boolean }).standalone === true;
    if (isIos && !standalone) setIosHint(true);

    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (deferred !== null) {
    return (
      <Button
        variant="ghost"
        size="sm"
        onClick={() => {
          void deferred.prompt();
          setDeferred(null);
        }}
      >
        Instalar o app
      </Button>
    );
  }
  if (iosHint) {
    return (
      <p className="type-caption text-text-tertiary">
        Para instalar: toque em <strong>Compartilhar</strong> → <strong>Adicionar à Tela de Início</strong>.
      </p>
    );
  }
  return null;
}
